export class PopTrigramFilterCriteria {
  name: string;
  displayId: string;
  continent: string;
  bwService: boolean;
  qedService: boolean;
  qrdService: boolean;
  qfdService: boolean;
  qhfService: boolean;
  newsService: boolean;

  constructor(userChoicesActiveFilters) {
    this.name = userChoicesActiveFilters.name;
    this.displayId = userChoicesActiveFilters.displayId;
    this.continent = userChoicesActiveFilters.continent;
    this.bwService = userChoicesActiveFilters.bwService;
    this.qedService = userChoicesActiveFilters.qedService;
    this.qrdService = userChoicesActiveFilters.qrdService;
    this.qfdService = userChoicesActiveFilters.qfdService;
    this.qhfService = userChoicesActiveFilters.qhfService;
    this.newsService = userChoicesActiveFilters.newsService;
  }
}
